/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Never_UsedInputs */

const en_settings_apikeys_never_used = /** @type {(inputs: Settings_Apikeys_Never_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never`)
};

/**
* | output |
* | --- |
* | "Never" |
*
* @param {Settings_Apikeys_Never_UsedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_never_used = /** @type {((inputs?: Settings_Apikeys_Never_UsedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Never_UsedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_never_used(inputs)
});
export { settings_apikeys_never_used as "settings.apikeys.never_used" }